<div class="wrap">
  <div class="header">
    <div class="title">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" (click)="goBack()" appChangeColorTheme attribute="color"></fa-icon>
      <h2>{{title}}</h2>
    </div>

    <div class="search_bar">
      <form [formGroup]="searchForm">
        <input type="text" [placeholder]="getPlacehokder()" (input)="applyFilter($event.target.value)"
          formControlName="keyword">
      </form>
      <fa-icon [icon]="!valueInput? getFaIcon('faSearch'): getFaIcon('faTimes')" (click)="valueInput ? resetSearch(): null"></fa-icon>
    </div>
  </div>

  <div class="content">
    <app-admin-offer-priority-solo *ngIf="userConnected.role === 'AdminMSR'" [clubCode]="clubCode">
    </app-admin-offer-priority-solo>
    <app-admin-offer-priority-by-club *ngIf="userConnected.role === 'admin'"></app-admin-offer-priority-by-club>

  </div>


</div>
